import { BasicPage } from './BasicPage';
export default BasicPage;
